import {createApp, watch} from 'vue';
import App from './App.vue';
import router from './router';
import {IonicVue} from '@ionic/vue';
import {i18n} from './locales/i18n.js';

/* Core & Utility CSS */
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme & Global Styles */
import './theme/variables/ionic.scss';
import './theme/global.scss';
import './theme/layout.scss';
import './theme/typo.scss';
import './theme/components/inputs.scss';
import './theme/components/modal.scss';
import './theme/components/typeBox.scss';

const app = createApp(App)
    .use(IonicVue)
    .use(router)
    .use(i18n);

watch(() => i18n.global.locale, (newLocale) => {
    document.documentElement.lang = newLocale;
});

document.documentElement.lang = i18n.global.locale;

router.isReady().then(() => {
    app.mount('#app');
});